import { render, staticRenderFns } from "./PaymentLogos.vue?vue&type=template&id=08f3e738&scoped=true&"
import script from "./PaymentLogos.vue?vue&type=script&lang=ts&"
export * from "./PaymentLogos.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentLogos.vue?vue&type=style&index=0&id=08f3e738&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f3e738",
  null
  
)

export default component.exports